"use client";

import styled from "styled-components";
import { Card, CardContent, CardHeader } from "../chartUi/card";

export const CardChart = styled(Card)`
  background: transparent;
  border: none;
  box-shadow: none;
`;

export const ChartContainer = styled(CardContent)`
  padding-left: 0;
  padding-right: 0;
`;

export const ChartHeader = styled(CardHeader)`
  padding: 0 0 15px 0;
  h2 {
    margin-bottom: 0;
  }
`;
